import LoadTestPageV2 from './LoadTestPageV2';
import CalibrationHost from '../load_test_components/CalibrationHost';

// Operations > Load Testing > Live Tests: the graph-first dashboard, with the
// Calibration window beside it. The classic dashboard (LoadTestPage) is
// switched off but kept in the code for now; it is no longer offered here.
function LoadTestDashboard() {
  return (
    <>
      <LoadTestPageV2 />
      <CalibrationHost />
    </>
  );
}

export default LoadTestDashboard;
